module.exports = __webpack_public_path__ + "img/火龙果2.29093d7f.png";